<template>
    <div id="company">
        <p class="view-title">企业管理</p>
        <!-- <p class="company-bin" @click="isBin=false" id="toList"><i><img :src="zuo" class="zuo"></i>企业回收站</p>  :class="{'organize':isBin}" -->
        <div ref="organizeBox" class="organizeBox">
            <organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @recovery="recovery" @setTree="setTree"></organize>
        </div>
        <!-- 列表 -->
        <div class="list-box" v-show="!isBin" style="top: 77px;">
            <header class="tabs-box clearfix ">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headerClick0"><span>全部</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headerClick1"><span>正常</span></div>
                <div :class="{'active':state==2}" @click="headClick(2)" id="headerClick2"><span>停用</span></div>
                <div :class="{'active':state==3}" @click="headClick(3)" id="headerClick3"><span>过期</span></div>
            </header>
            <div class="bg top-0">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="clickAdd" id="addCom" :disabled="!functionSet.includes('companyEdit')||$store.state.isLook">新建企业</el-button>
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="search" id="searchCom">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入企业简称、全称或ID"
                            v-model="searchVal" class="search-input" @keyup.enter.native="search">
                            <i slot="suffix" class="el-input__icon el-icon-search" id="searchInp"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li class="w-18">企业简称</li>
                        <li class="w-18">分组</li>
                        <li class="w-90">启用状态</li>
                        <li>到期时间</li>
                        <li class="t-right w-90">授权点数</li>
                        <li class="min-158">操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li class="w-18" :title="item.shortName">{{item.shortName}}</li>
                            <li class="w-18" :title="item.groupName">{{item.groupName}}</li>
                            <li class="w-90" :class="{'color-red':item.state != 1}">{{item.state == 1? '已启用':item.state == 2?'停用':'过期'}}</li>
                            <li :title="changeDate(item.expiredDate)">{{changeDate(item.expiredDate)}}</li>
                            <li class="t-right w-90">{{item.userLimit}}</li>
                            <li class="operate min-158">
                                <span @click='editCompanyShow(i)' :id="`edit${i}`">{{functionSet.includes('companyEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" v-show='item.state==2||item.state==3' @click="operate('enableShow',i)" :id="`enable${i}`">启用</span>
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" v-show='item.state==1' @click="operate('disShow',i)" :id="`disable${i}`">停用</span>
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" @click="clear(i)" :id="`clear${i}`">清理</span>
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" @click="operate('delShow',i)" :id="`del${i}`">删除</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 回收站 -->
        <div class="list-box" v-show="isBin">
            <div class="bg top-0">
                <div class="list-top clearfix">
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="searchBin" id="searchBinBtn">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入企业简称、全称或ID"
                            v-model="searchBinVal" class="search-input" @keyup.enter.native="searchBin">
                            <i slot="suffix" class="el-input__icon el-icon-search" id="searchBinInp"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li class="w-18">企业简称</li>
                        <li class="w-18">分组</li>
                        <li class="w-90">启用状态</li>
                        <li>到期时间</li>
                        <li class="t-right w-90">授权点数</li>
                        <li >操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in recoveryList" :key="i" v-show="recoveryList.length != 0">
                            <li class="w-18">{{item.shortName}}</li>
                            <li class="w-18" :title="item.groupName">{{item.groupName}}</li>
                            <li class="w-90" :class="{'color-red':item.state != 1}">{{item.state == 1? '已启用':item.state == 2?'停用':'过期'}}</li>
                            <li :title="changeDate(item.expiredDate)">{{changeDate(item.expiredDate)}}</li>
                            <li class="t-right w-90">{{item.userLimit}}</li>
                            <li class="operate">
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" @click="clear(i)" :id="`clearBin${i}`">清理</span>
                                <span :class="{'disabled':!functionSet.includes('companyEdit')||$store.state.isLook}" @click="operate('recoveryShow',i)" :id="`recoveryBin${i}`">恢复</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="recoveryList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 删除企业 -->
            <div class="popup-del" v-show='delShow'>
                <div class="popup-title m-b-22">
                    删除企业<i class="el-icon-circle-close close" @click="close('del')" id="closeDel1"></i>
                </div>
                <div class="popup-lab t-left">
                    <p>系统将删除该企业"{{nowObj.name}}"，是否继续？</p>
                    <p class="popup-btn-box"><el-button type="primary" @click='yes' :disabled="!functionSet.includes('companyEdit')" id="yesDel">确定</el-button> <el-button @click="close('del')" id="closeDel2">取消</el-button></p>
                </div>
            </div>
            <!-- 清理企业 -->
            <div class="popup-clear" v-show='clearShow'>
                <div class="popup-title">
                    清理企业设备历史数据<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('clear')" id="closeClear1"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix" >
                    <p><i class="star">*</i>验证码：</p>
                    <!-- <input type="text" id="verifyCode" class="verifyCode" placeholder="请输入4位验证码" v-model='verifyCode' maxlength="4" @keyup="inputChange('verifyCode')"> -->
                    <el-form style="float: left; width: 255px;" :model="ruleForm" :rules="rules" ref="ClearVerifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="toClear" v-model='ruleForm.verifyCode' maxlength="4" @input="inputChange('verifyCode')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click='toClear' :disabled="!functionSet.includes('companyEdit')" id="toClear">确定</el-button>
                        <!-- <el-button disabled type="primary"  v-show='verifyCode.length != 4'>确定</el-button>  -->
                        <el-button @click="close('clear')" id="closeClear2">取消</el-button>
                    </p>
                </div>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('function')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode3" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <!-- <input type="text" > -->
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('function')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
            <!-- 新增企业 -->
            <div class="popup-add" v-show='addShow'>
                <div class="popup-title">
                    新建企业</i><i class="el-icon-circle-close close" @click="close('add')" id="closeAdd1"></i>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <div class="popup-lab edit-content clearfix">
                        <div class="left-box">
                            <p class="left-title">企业基本信息</p>
                            <el-form-item label="企业简称：" autocomplete="off" prop="shortName">
                                <i><img :src="notes" title="企业简称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.shortName" id="addShortName"></el-input>
                            </el-form-item>
                            <el-form-item label="企业全称：" autocomplete="off" prop="name">
                                <i><img :src="notes" title="企业全称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name" id="addName"></el-input>
                            </el-form-item>
                            <div class="popup-lab">
                                <p style="margin-left: -10px;"><i class="star">*</i>所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes"></i></p>
                                <div class="or-Superior" @click='showSelect' id="addOrg1" @mouseleave="selectShow=false">
                                    {{orSuperior.name}}
                                    <i><img :src="down" @click="showSelect" id="addOrg2"></i>
                                    <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                        <div class="dashed">
                                            <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                    <span>{{ node.label }} <span v-if='data.roleName'>({{data.roleName}})</span></span>
                                                </span>
                                            </el-tree>
                                        </div>
                                    </div>
                                </div>
                                <span ref="addOrMax" class="red addMax">操作失败，此操作将导致组织层级超过10级</span>
                            </div>
                        </div>
                        <div class="right-box p-r">
                            <p class="left-title">企业运维展示信息</p>
                            <p class="logo clearfix">
                                <span>企业logo：</span>
                                <span class="logo-box"><input type="file" ref="addfile" class="file" accept="image/*" id="addfile"><img :src="ruleForm.file" @click="clickFile('add')" ref='addImg' id="addFileImg"></span>
                                <span @click="clickFile('add')" class="c-pointer" id="addFileBtn">上传图片<i><img :src="notes" title="仅支持小于2MB的JPG和PNG文件" class="notes"></i></span>
                            </p>
                            <p class="red logoTip" ref="addlogo">仅支持小于2MB的JPG和PNG文件</p>
                            <el-form-item label="企业标题：" autocomplete="off" prop="title">
                                <i><img :src="notes" title="企业标题支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.title" id="addTitle"></el-input>
                            </el-form-item>
                        </div>
                        <div class="left-box">
                            <p class="left-title">企业授权信息</p>
                            <el-form-item label="授权点数：" autocomplete="off" prop="userLimit">
                                <i><img :src="notes" title="企业可添加的设备数量，0表示不限制，最大99999" class="notes"></i>
                                <el-input v-model.number="ruleForm.userLimit" id="addMaxDevice"></el-input>
                            </el-form-item>
                            <el-form-item label="到期时间：" autocomplete="off" prop="radio">
                                <i><img :src="notes" title="企业运维可用时间，不选择表示不限制，最长支持100年" class="notes"></i>
                                <el-radio-group v-model="ruleForm.radio" id="addRadio" @change="changeRadio">
                                    <el-radio :label="1">设置</el-radio>
                                    <el-radio :label="2">不设置</el-radio>
                                </el-radio-group>
                                <el-date-picker
                                    v-model="ruleForm.endDate"
                                    type="date"
                                    placeholder="选择日期"
                                    :disabled='ruleForm.radio == 2'
                                    :clearable='false'
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    :editable='false'
                                    id="addDate"
                                    >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="到期是否停用：">
                                <el-radio-group v-model="ruleForm.autoStop" id="addAutoStop" :disabled='ruleForm.radio == 2'>
                                    <el-radio :label=1>是</el-radio>
                                    <el-radio :label=0>否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="解决方案：">
                              <el-checkbox checked disabled class="f-l" style="margin-right: 12px;">通用解决方案</el-checkbox>
                              <el-checkbox-group v-model="ruleForm.module">
                                <el-checkbox label="Energy">能源管理</el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <div class="right-box">
                            <p class="left-title">其他信息</p>
                            <el-form-item label="所属行业：" prop="tradeId">
                                <el-select v-model="ruleForm.tradeId" placeholder="请选择" class="industry" id="addTrade">
                                    <el-option
                                    v-for="item in industryData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="企业地址：" prop='province' class="address">
                                <el-select v-model="ruleForm.provinceId" placeholder="请选择" class="province" @change="setprovince" id="addProvince">
                                    <el-option
                                    v-for="item in regionData.provinces"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                    >
                                    </el-option>
                                </el-select>
                                <el-select v-model="ruleForm.cityId" placeholder="请选择" class="city" :disabled="ruleForm.provinceId==null" id="addCity">
                                    <el-option
                                    v-for="item in areaData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="addNote"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="popup-lab">
                    <p class="btn-box"><el-button type="primary" @click="addCompany('ruleForm')" id="yesAdd">确定</el-button> <el-button  @click="close('add')" id="closeAdd2">取消</el-button></p>
                </div>
            </div>
            <!-- 编辑企业 -->
            <div class="popup-edit" v-show='editShow'>
                <div class="popup-title">
                    {{functionSet.includes('companyEdit')&&!$store.state.isLook?'编辑':'查看'}}企业</i><i class="el-icon-circle-close close" @click="close('edit')" id="closeEdit1"></i>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" :disabled="!functionSet.includes('companyEdit')||$store.state.isLook">
                    <div class="popup-lab edit-content clearfix">
                        <div class="left-box">
                            <p class="left-title">企业基本信息</p>
                            <p>企业ID：{{ruleForm.code}}</p>
                            <el-form-item label="企业简称：" autocomplete="off" prop="shortName">
                                <i><img :src="notes" title="企业简称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.shortName" id="editShortName"></el-input>
                            </el-form-item>
                            <el-form-item label="企业全称：" autocomplete="off" prop="name">
                                <i><img :src="notes" title="企业全称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name" id="editName"></el-input>
                            </el-form-item>
                            <div class="popup-lab">
                                <p style="margin-left: -10px;"><i class="star">*</i>所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes"></i></p>
                                <div class="or-Superior" @click='showSelect' id="editOrg1" @mouseleave="selectShow=false" v-show="functionSet.includes('companyEdit')&&!$store.state.isLook">
                                    {{orSuperior.name}}
                                    <i><img :src="down" @click="showSelect" id="editOrg2"></i>
                                    <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                        <div class="dashed">
                                            <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                    <span>{{ node.label }} <span v-if='data.roleName'>({{data.roleName}})</span></span>
                                                </span>
                                            </el-tree>
                                        </div>
                                    </div>
                                </div>
                                <div class="or-Superior disabled3" v-show="!functionSet.includes('companyEdit')||$store.state.isLook">
                                    {{orSuperior.name}}
                                    <i><img :src="down"></i>
                                </div>
                                <span ref="addOrMax" class="red addMax">操作失败，此操作将导致组织层级超过10级</span>
                            </div>
                        </div>
                        <div class="right-box p-r">
                            <p class="left-title">企业运维展示信息</p>
                            <p class="logo clearfix">
                                <span>企业logo：</span>
                                <span class="logo-box" v-if="ruleForm.logo"><input type="file" ref="editfile" class="file" accept="image/*" id="editFileInp"><img :src="`${$store.state.imgUrl+ruleForm.logo}`" @click="clickFile('edit')" ref='editImg' id="editFileImg"></span>
                                <span @click="clickFile('edit')" class="c-pointer" id="editFileBtn">上传图片<i><img :src="notes" title="仅支持小于2MB的JPG和PNG文件" class="notes"></i></span>
                            </p>
                            <p class="red logoTip" ref="editlogo">仅支持小于2MB的JPG和PNG文件</p>
                            <el-form-item label="企业标题：" autocomplete="off" prop="title">
                                <i><img :src="notes" title="企业标题支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.title" id="editTitle"></el-input>
                            </el-form-item>
                            <el-form-item label="企业数据：" autocomplete="off">
                                <i><img :src="notes" title="企业标题支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <div style="width: 100%;">
                                    <el-button type="primary" size="small">备份</el-button>
                                    <el-button type="primary" size="small">还原</el-button>
                                    <el-button type="warning" size="small">清理</el-button>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="left-box">
                            <p class="left-title">企业授权信息</p>
                            <el-form-item label="授权点数：" autocomplete="off" prop="userLimit">
                                <i><img :src="notes" title="企业可添加的设备数量，0表示不限制，最大99999" class="notes"></i>
                                <el-input v-model.number="ruleForm.userLimit" id="editMaxDevice"></el-input>
                            </el-form-item>
                            <el-form-item label="到期时间：" autocomplete="off" prop="radio">
                                <i><img :src="notes" title="企业运维可用时间，不选择表示不限制，最长支持100年" class="notes"></i>
                                <el-radio-group v-model="ruleForm.radio" id="editRadio" @change="changeRadio">
                                    <el-radio :label="1">设置</el-radio>
                                    <el-radio :label="2">不设置</el-radio>
                                </el-radio-group>
                                <el-date-picker
                                    v-model="ruleForm.endDate"
                                    type="date"
                                    placeholder="选择日期"
                                    :disabled='ruleForm.radio == 2?true:false'
                                    :clearable='false'
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    :editable='false'
                                    id="editDate"
                                    >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="到期是否停用：">
                                <el-radio-group v-model="ruleForm.autoStop" id="editAutoStop" :disabled='ruleForm.radio == 2'>
                                    <el-radio :label=1>是</el-radio>
                                    <el-radio :label=0>否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="解决方案：">
                              <el-checkbox checked disabled class="f-l" style="margin-right: 12px;">通用解决方案</el-checkbox>
                              <el-checkbox-group v-model="ruleForm.module">
                                <el-checkbox label="Energy">能源管理</el-checkbox>
                              </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <div class="right-box">
                            <p class="left-title">其他信息</p>
                            <el-form-item label="所属行业：" prop="tradeId">
                                <el-select v-model="ruleForm.tradeId" placeholder="请选择" class="industry" id="editTrade">
                                    <el-option
                                    v-for="item in industryData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="企业地址：" prop='province' class="address">
                                <el-select v-model="ruleForm.provinceId" placeholder="请选择" class="province" @change="setprovince" id="editProvince">
                                    <el-option
                                    v-for="item in regionData.provinces"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                    >
                                    </el-option>
                                </el-select>
                                <el-select v-model="ruleForm.cityId" placeholder="请选择" class="city" :disabled="ruleForm.provinceId==null" id="editCity">
                                    <el-option
                                    v-for="item in areaData"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="editNote"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="popup-lab">
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('companyEdit')||$store.state.isLook" @click="editCompany('ruleForm2')" id="yesEdit">确定</el-button> <el-button  @click="close('edit')" id="closeEdit2">取消</el-button></p>
                </div>
            </div>
            <!-- 启用企业 -->
            <div class="popup-delDevice" v-show="enableShow">
                <div class="popup-title">
                    启用企业<i class="el-icon-circle-close close" @click="close('enable')" id="closeEnble1"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将启用该企业"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('companyEdit')" @click="enableCom" id="yesEnable">确定</el-button> <el-button @click="close('enable')" id="closeEnble2">取消</el-button></p>
                </div>
            </div>
            <!-- 停用企业 -->
            <div class="popup-delDevice" v-show="disShow">
                <div class="popup-title">
                    停用企业<i class="el-icon-circle-close close" @click="close('dis')" id="closeDis1"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将停用该企业"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('companyEdit')" @click="disCom" id="yesDis">确定</el-button> <el-button @click="close('dis')" id="closeDis2">取消</el-button></p>
                </div>
            </div>
            <!-- 恢复企业 -->
            <div class="popup-delDevice" v-show="recoveryShow">
                <div class="popup-title">
                    恢复企业<i class="el-icon-circle-close close" @click="close('recovery')" id="closeRecovery1"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将恢复该企业"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('companyEdit')" @click="recoveryCom" id="yesRecovery">确定</el-button> <el-button @click="close('recovery')" id="closeRecovery2">取消</el-button></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/PublicAssembly/pagination"
    import Organize from "@/components/PublicAssembly/organize"
    import Region from "../../assets/js/region.js"
    export default {
        data() {
            var validateName = (rule, value, callback) =>{
                let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
                if(value == ""){
                    callback(new Error('企业全称不能为空'));
                }else if(!reg.test(value)){
                    callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'))
                }else{
                    callback();
                }
            }
            var validateName2 = (rule, value, callback) =>{
                let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
                if(value == ""){
                    callback(new Error('企业简称不能为空'));
                }else if(!reg.test(value)){
                    callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'))
                }else{
                    callback();
                }
            }
            var validateTitle = (rule, value, callback) =>{
                let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
                if(value == ""){
                    callback(new Error('企业标题不能为空'));
                }else if(!reg.test(value)){
                    callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'))
                }else{
                    callback();
                }
            }
            var validateMax = (rule, value, callback) =>{
                if(value==0){
                    callback();
                }else if (value >99999 || value < -1 || value === '' || !Number.isInteger(value)) {
                    callback(new Error('请输入0~99999的整数'));
                }else {
                    callback();
                }
            }
            var validateDate = (rule, value, callback) =>{
                if (value == 1 && this.ruleForm.endDate == '') {
                    callback(new Error('请选择到期时间'));
                }else {
                    callback();
                }
            }
            var validatorAddress = (rule, value, callback) =>{
                if (this.ruleForm.provinceId == null || this.ruleForm.cityId == null) {
                    callback(new Error('必须选择企业所在地区'));
                }else {
                    callback();
                }
            }
            return {
                dataList:[],
                searchVal:'',
                searchBinVal:'',
                recoveryName:'企业回收站',
                delShow:false,
                clearShow:false,
                addShow:false,
                editShow:false,
                enableShow:false,
                disShow:false,
                isBin:false,        //回收站显示
                recoveryList:[],    //回收站列表
                recoveryShow:false, //恢复
                totalCount:1,
                notes:require('@/assets/image/organize/notes.png'),
                down:require('@/assets/image/organize/down.png'),
                logo:require('@/assets/image/company/logo.png'),
                zuo:require('@/assets/image/index/zuo.png'),
                nullData:require('@/assets/image/index/nullData.png'),
                area:require('@/assets/image/company/qyzu.png'),
                branch:require('@/assets/image/company/ptzu.png'),
                location:require('@/assets/image/company/jczu.png'),
                verifyCode:"",    //验证码
                getCodeShow:true,
                selectShow:false,
                timer:null,     //计时器
                second:60,      //倒计时
                countdownShow:false,
                state:0,        //控制按钮颜色（企业状态）
                pageSize:0,
                pageNumber:1,
                orSuperior:{},      //上级组对象
                orSuperiorData:[],  //所属组tree结构数据
                roleId:null,        //用户当前角色id
                functionSet:[],     //权限列表
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                stop:'1',
                date:null,
                ispageSize:true,
                industry:null,      //行业
                industryData:null,  //行业数据
                province:null,      //省
                city:null,          //市
                regionData:Region.customData(),     //省份数据
                areaData:null,      //市区数据
                name:null,          //企业简称
                shortName:null,     //企业全称
                title:null,         //企业标题
                note:null,          //备注
                userLimit:0,     //最大用户数
                setIndex:null,      //修改企业下标
                nowObj:{},        //当前修改企业对象
                orCode:null,        //当前组code
                isSearch:false,
                formdata: '',
                endDate:null,
                phone:'',
                noGet:false,
                ruleForm: {         //验证表单参数
                    name: '',
                    shortName: '',
                    groupId:null,
                    title: '',
                    file:require('@/assets/image/company/logo.png'),
                    radio: 1,
                    endDate: '',
                    autoStop: 1,
                    tradeId:null,
                    provinceId:null,
                    cityId:null,
                    note: '',
                    userLimit:0,
                    module:[],
                },

                verifyForm:{
                    verifyCode:'',
                },
                rules: {            //验证规则
                    name: [
                        { required: true, message: '请输入全称', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }
                    ],
                    shortName: [
                        { required: true, message: '请输入简称', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }
                    ],
                    title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }
                    ],
                    userLimit: [
                        { validator: validateMax, required: true, trigger: 'blur' }
                    ],
                    radio: [
                        { validator: validateDate, required: true, trigger: 'blur' }
                    ],
                    province:[
                        { validator: validatorAddress, required: true, trigger: 'blur'}
                    ],
                    tradeId:[{required: true, message:"所属行业不能为空", trigger: 'blur'}],
                    verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }]
                },
                isCount:true,
                functionShow:false,
                VerifyArr:[],
                istrue:true,
                oldNum:1,
            }
        },
        components:{
            Pagination,
            Organize
        },
        created() {
            this.$store.state.activeIndex = '/company'
            this.pageSize=this.$store.state.userConfig.rowsPerPage;
            this.getIndustry()
            this.getTree('a')
            this.phone=this.$store.state.userData.mobile?this.hidePhone(this.$store.state.userData.mobile):this.hidePhone(JSON.parse(localStorage.getItem('userData')).mobile);
            console.log(this.phone)
        },
        methods: {
            // 获取组织树
            getTree(type){
                this.get('/Group/getGroupTree').then((res)=>{
                    if(res.success){
                        this.$store.state.treeData=res.result;
                        if(res.result.length==0){
                            return
                        }
                        // console.log(this.$store.state.treeData)
                        this.$store.state.expandedArr=[]
                        this.expanded(this.$store.state.treeData,1)
                        this.orSuperior = this.clone(this.$store.state.treeData[0])
                        this.oldorSuperior = this.clone(this.orSuperior)
                        this.functionSet = this.$store.state.treeData[0].functionSet.split(',')
                        if(type == 'a'){
                            this.getlist({pageNumber:1,length:this.pageSize,groupCode:this.orSuperior.code});   //获取列表
                            this.roleId = this.$store.state.treeData[0].roleId    //获取第一个角色id
                            this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)    //平台参数设置中需要短信验证码提权的部分
                        }
                        this.orSuperiorData=[]  //初始化树
                        for(let obj of res.result){
                            if(obj.roleId == this.roleId){  //获取当前角色下树数据
                                obj = this.clone(obj)
                                this.orSuperiorData.push(obj)
                                return
                            }
                        }
                    }
                }) .then(()=>{
                    this.istrue=false
                    // this.$children[0].$emit('getTree',false)
                })
            },
            setTree(){
                this.getTree()
            },
            //获取行业类别
            getIndustry(){
                this.get('/Dict/getListByType',{type:1}).then((res)=>{
                    this.industryData=res.result
                })
            },
            //选择图片
            clickFile(name){
                let fileName = name + 'file';
                let imgName = name + 'Img';
                let inp = this.$refs[fileName];
                inp.click();
                let that = this;
                inp.onchange = function(e) {
                    let fileList =that.$refs[fileName].files;   //获取上传文件
                    let file = fileList[0];                     //文件参数
                    let size = file.size/1024;                  //文件大小
                    const fileReader = new FileReader()
                    fileReader.readAsDataURL(file)              //读取图片
                    fileReader.addEventListener('load', function() {
                        this.logo = fileReader.result;          // 读取完成
                        that.ruleForm.file = fileReader.result
                        that.$refs[imgName].src = this.logo;    //修改logo
                    })
                    if(size/1000 > 2){
                        that.addShow == true ? that.$refs.addlogo.style.display='block':that.$refs.editlogo.style.display='block';
                        return
                    }else{
                        that.addShow == true ? that.$refs.addlogo.style.display='none':that.$refs.editlogo.style.display='none'
                    }
                }
            },
            // 获取列表
            getlist(parm){
                if(this.$store.state.treeData.length==0) return
                this.get('/Company/query',parm).then((res)=>{
                    if(res.success){
                        this.dataList=res.result.data
                        if(this.isCount){
                            this.totalCount=res.result.totalCount
                            this.isCount=false;
                        }
                    }else{
                        this.message({
                            type:'warning',
                            message:`获取列表数据失败：${res.message}`
                        })
                    }
                })
            },
            //获取回收站数据
            getBinList(parm){
                this.get('/Company/queryBin',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.recoveryList = res.result.data
                        this.totalCount=res.result.totalCount
                    }else{
                        this.message({
                            type:'warning',
                            message:`获取列表数据失败：${res.message}`
                        })
                    }
                })
            },
            // 头部标签
            headClick(i){
                this.state=i;
                if(this.$store.state.treeData.length==0) return
                this.isCount=true
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    state:i,
                    groupCode:this.orCode||this.orSuperior.code,
                    keyword:this.searchVal
                }
                this.getlist(parm);
                this.pageNumber = 1;
                this.noGet=true
            },
            // 修改分页size
            setSize(pageObj){
                if(this.$store.state.treeData.length==0) return //当前没有组织
                if(this.istrue){
                    return
                }
                this.pageSize=pageObj.size;
                let parm={
                    pageNumber:pageObj.number,
                    length:pageObj.size,
                    state:this.state,
                    groupCode:this.orCode||this.orSuperior.code,
                    keyword:this.searchVal
                }
                this.getlist(parm);
            },
            // 修改页数
            setNum(number){
                if(this.$store.state.treeData.length==0) return
                if(this.noGet){
                    this.noGet = false
                    // console.log(noGet)
                    return
                }
                if(this.oldNum==number){
                    return    //当前页数与旧页数一致
                }else{
                    this.oldNum = number
                }
                this.pageNumber=Number(number);
                if(this.isBin){ //当前为回收站列表
                    let parm = {
                        pageNumber:number,
                        length:this.pageSize,
                        keyword:this.searchBinVal
                    }
                    this.getBinList(parm)
                }else{
                    let parm ={
                        pageNumber:number,
                        length:this.pageSize,
                        state:this.state,
                        groupCode:this.orCode,
                        keyword:this.searchVal
                    }
                    this.getlist(parm);
                }
            },
            // 获取的当前组
            setOrId(node){
                this.roleId = node[0].roleId
                this.orSuperiorData = []
                for(let obj of this.$store.state.treeData){
                    if(node[0].roleId == obj.roleId){   //获取当前角色下的树数据
                        obj = this.clone(obj)
                        this.orSuperiorData.push(obj)
                        // console.log(this.orSuperiorData)
                    }
                }
                this.orCode=node[0].code;
                this.isBin =false
                this.orSuperior=this.clone(node[0]);
                this.oldorSuperior = this.clone(this.orSuperior)
                this.functionSet = node[1]
                // this.noGet=true
                this.searchVal=''
                this.oldNum = 1
                this.pageNumber=1
                let parm = {
                    pageNumber:this.pageNumber,
                    length:this.pageSize,
                    state:this.state,
                    groupCode:this.orCode,
                    keyword:this.searchVal
                }
                this.isCount = true
                this.getlist(parm)
            },
            // 操作-清理设备
            clear(i){
                if(!this.functionSet.includes('companyEdit')){
                    return
                }
                this.setIndex=i;
                this.$store.state.mask=true;
                this.clearShow=true;
                this.verifyCode = ""
            },
            //打开弹窗
            operate(name,i){
                if(this.VerifyArr.includes(2)&&!this.$store.state.isLook&&this.functionSet.includes('companyEdit')){
                    this.$store.state.mask = true
                    this.functionShow=true
                    return
                }
                if(name=='editShow'){
                    // console.log(this.nowObj)
                    this[name]=true;
                    this.$store.state.mask=true;
                }
                if(!this.functionSet.includes('companyEdit')||this.$store.state.isLook){
                    return
                }
                if(this.isBin){
                    this.nowObj = this.clone(this.recoveryList[i])
                }else{
                    this.nowObj = this.clone(this.dataList[i]);
                }
                this.setIndex = i;
                this[name]=true;
                this.$store.state.mask=true;
            },
            // 关闭弹窗
            close(name){
                this.ruleForm=this.$options.data().ruleForm
                this.$store.state.mask=false
                this.verifyForm.verifyCode = ''
                name = name+'Show';
                this[name] = false;
                if(name=='clearShow'||name=="functionShow"){
                    this.getCodeShow = true;
                    this.countdownShow=false;
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            //确定删除企业
            yes(){
                let parm = {id:this.dataList[this.setIndex].id}
                this.get('/Company/remove',parm).then((res)=>{
                    if(res.success){
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        // this.dataList.splice(this.setIndex,1)
                        this.search()
                    }else{
                        this.$message({
                            type: 'warning',
                            message: `删除失败：${res.message}`
                        });
                    }
                    this.delShow=false;
                    this.$store.state.mask=false;
                })
            },
            // 确定清除设备信息
            toClear(){
              this.$refs.ClearVerifyCode.validate((valid) => {
                console.log(valid)
                if(valid){
                  let parm={
                      id:this.dataList[this.setIndex].id,
                      verifyCode:Number(this.ruleForm.verifyCode)
                  }
                  this.get('/Company/clearDeviceData',parm).then((res)=>{
                      if(res.success){
                          this.$message({
                              type: 'success',
                              message: '清理成功'
                          });
                          this.$store.state.mask=false
                          this.clearShow=false
                      }else{
                          this.$message({
                              type: 'warning',
                              message: `清理失败：${res.message}`
                          });
                      }
                  })
                }
              })

            },
            // 获取验证码
            getCode(a){
                // console.log(a)
                let parm = {}
                if(a==true){
                    parm.mobile = this.$store.state.userData.mobile
                    this.post('/UserProfile/sendVerifyCode',parm).then((res)=>{
                        if(res.success){
                            this.getCodeShow=false
                            this.countdownShow=true
                            const TIME_COUNT = 60;
                            this.$message({
                                message: '验证码发送成功',
                                type: 'success'
                            });
                            if (!this.timer) {
                                this.second = TIME_COUNT;
                                this.show = false;
                                this.timer = setInterval(() => {
                                    if (this.second > 0 && this.second <= TIME_COUNT) {
                                        this.second--;
                                    } else {
                                        this.getCodeShow = true;
                                        this.countdownShow=false;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000)
                            }
                        }
                    })
                }else{
                    this.get('/UserProfile/sendVerifyCode').then((res)=>{
                        if(res.success){
                            this.getCodeShow=false
                            this.countdownShow=true
                            const TIME_COUNT = 60;
                            this.$message({
                                message: '验证码发送成功',
                                type: 'success'
                            });
                            if (!this.timer) {
                                this.second = TIME_COUNT;
                                this.show = false;
                                this.timer = setInterval(() => {
                                    if (this.second > 0 && this.second <= TIME_COUNT) {
                                        this.second--;
                                    } else {
                                        this.getCodeShow = true;
                                        this.countdownShow=false;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000)
                            }
                        }
                    })
                }

            },
            // 展开上级组
            showSelect(){
                var box = this.$refs.selectbox;
                this.selectShow=true;
            },
            // 获取用户点击的上级组节点
            selectId(data){
                this.orSuperior=data;
                this.ruleForm.groupId=data.id;
                this.selectShow=false;
                // 是否展开编辑页面
                if(this.editShow){
                    // this.getLevel(1,this.treeObj.children);
                    // 检测用户选择上级组是否发生超出层级问题
                    if(this.orSuperior.level==undefined && this.level + 2 >= 9){
                        this.$refs.editMaxTips.style.display='block';
                        this.maxTrue=false;
                    }else if(this.level+this.orSuperior.level > 9){
                        this.$refs.editMaxTips.style.display='block';
                        this.maxTrue=false;
                    }else{
                        this.$refs.editMaxTips.style.display='none';
                        this.isTrue=true;
                    }
                }
            },
            getLevel(level,data){
                this.level=level
                if (!data) {
                    return level;
                }
                this.getLevel(level + 1,data[0].children);
            },
            //新增企业弹窗
            clickAdd(){
                if(this.VerifyArr.includes(2)){
                    this.$store.state.mask = true
                    this.functionShow=true
                    return
                }
                this.addShow=true;
                this.$store.state.mask=true;
                this.orSuperior = this.clone(this.oldorSuperior)
            },
            //选择省份后更新市区数据
            setprovince(data,setCid){
                // console.log(this.ruleForm.cityId)
                if(!setCid){
                    this.ruleForm.cityId = null
                }
                for(let value of this.regionData.provinces){
                    value.id = Number(value.id)
                    if(value.code == data){
                        this.areaData = value.cities;
                        this.city = null;
                    }
                }
                if(setCid){
                    let radio = this.ruleForm.radio
                    this.ruleForm.radio = radio
                    // console.log(this.ruleForm.endDate)
                    this.$store.state.mask=true;
                    this.editShow=true;
                }
            },
            //编辑企业弹窗
            editCompanyShow(i){
                if(this.VerifyArr.includes(2)&&!this.$store.state.isLook&&this.functionSet.includes('companyEdit')){
                    this.$store.state.mask = true
                    this.functionShow=true
                    return
                }
                this.setIndex = i;
                let obj ;
                this.get('/Company/get',{id:this.dataList[i].id}).then((res)=>{
                    if(res.success){
                        obj = res.result
                        // console.log(!obj.expiredDate)
                        if(!obj.expiredDate){
                            obj.radio=2;
                            obj.endDate = null
                        }else{
                            obj.radio = 1
                            obj.endDate = this.changeDate(obj.expiredDate)
                        }
                        obj.provinceId=obj.provinceId.toString();
                        obj.cityId=obj.cityId.toString();
                        obj.module=obj.module?obj.module.split(','):[];
                        this.ruleForm = obj
                        this.logo=this.ruleForm.logo;
                        this.orSuperior.id=this.ruleForm.groupId;
                        this.orSuperior.name=this.ruleForm.groupName;
                        this.setprovince(this.ruleForm.provinceId,true)
                    }else{
                        this.$message({
                            type:'warning',
                            message:`获取企业数据失败：${res.message}`
                        })
                    }
                })
            },
            //新增企业
            addCompany(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let parm = this.clone(this.ruleForm);
                        // console.log(parm)
                        if(parm.radio == 2){
                            parm.endDate=''
                        }else{
                            parm.endDate = new Date(parm.endDate).getTime().toString()
                        }
                        if(parm.groupId==null){
                            parm.groupId = this.orSuperior.id
                        }
                        if(parm.tradeId==null){
                            parm.tradeId = 0
                        }else{
                            parm.tradeId = Number(parm.tradeId)
                        }
                        parm.groupName = this.orSuperior.name;
                        parm.module = parm.module.toString();
                        parm.provinceId = Number(parm.provinceId);
                        parm.cityId = Number(parm.cityId);
                        // console.log(parm.file == this.logo)
                        if(parm.file == this.logo){
                            parm.file = null
                        }else{
                            parm.file = this.dataURItoBlob(parm.file)
                        }

                        let formdata = new FormData();
                        Object.keys(parm).map(key=>{
                            formdata.append(key,parm[key]);
                        });
                        this.postForm('/Company/create', formdata).then((res) => {
                            if(res.success){
                                this.$message({
                                    type: 'success',
                                    message: '创建成功'
                                });
                                this.search()
                                this.addShow=false;
                                this.$store.state.mask=false;
                                this.ruleForm=this.$options.data().ruleForm
                            }else{
                                this.$message({
                                    type: 'warning',
                                    message: `创建失败：${res.message}`
                                });
                            }
                        })

                    } else {
                        return false;
                    }
                });
            },
            //修改企业
            editCompany(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let data = this.clone(this.ruleForm);
                        let parm={         //验证表单参数
                            id:data.id,
                            code:data.code,
                            name: data.name,
                            shortName: data.shortName,
                            title: data.title,
                            radio: data.radio,
                            autoStop: data.autoStop,
                            note: data.note,
                            userLimit:data.userLimit,
                            module:data.module,
                        }
                        parm.provinceId = Number(data.provinceId);
                        parm.cityId = Number(data.cityId);
                        parm.module = parm.module.toString();
                        if(!data.endDate || data.radio == 2){
                            data.endDate = ""
                        }else{
                            parm.endDate = new Date(data.endDate).getTime().toString()
                        }
                        if(data.file){
                            parm.file = this.dataURItoBlob(data.file);
                        }else{
                            parm.logo = data.logo
                        }
                        if(data.tradeId==null){
                            parm.tradeId = 0
                        }else{
                            parm.tradeId = Number(data.tradeId)
                        }
                        parm.groupId = data.groupId
                        let formdata = new FormData();
                        Object.keys(parm).map(key=>{
                            formdata.append(key,parm[key]);
                        });
                        this.postForm('/Company/update',formdata).then((res) => {
                            if(res.success){
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                });
                                this.getCompany(this.ruleForm.id)
                                this.editShow=false;
                                this.$store.state.mask=false;
                                this.ruleForm=this.$options.data().ruleForm
                            }else{
                                this.$message({
                                    type: 'warning',
                                    message: `修改失败：${res.message}`
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //获取企业
            getCompany(id){
                this.get('/Company/get',{id:id}).then((res)=>{
                    if(res.success){
                        this.dataList[this.setIndex] = res.result
                    }
                    this.editShow=false;
                    this.$store.state.mask=false;
                    this.$forceUpdate()
                })
            },
            //数字输入框值改变
            inputChange(regObj){
                if(regObj=='userLimit'){
                    this.userLimit = this.userLimit.replace(/[^\d]/g, '');
                }else if(regObj=='verifyCode'){
                    this.verifyCode = this.verifyCode.replace(/[^\d]/g, '');
                }
            },
            //搜索
            search(){
                // this.pageNumber=1
                this.isCount=true
                let parm = {
                    pageNumber:this.pageNumber,
                    length:this.pageSize,
                    state:this.state,
                    groupCode:this.orCode || this.$store.state.treeData[0].code,
                    keyword:this.searchVal
                }
                this.getlist(parm);
            },
            searchBin(){
                this.pageNumber=1
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    keyword:this.searchBinVal
                }
                this.getBinList(parm);
            },
            // 验证最大授权
            testMax(obj){
                let Tip=obj + 'Tips'
                Tip = this.$refs.Tip
                let input = this.$refs.obj;
                if(this.userLimit < -1 || this.userLimit > 99999 ||this.userLimit === ""){
                    // console.log(false)
                    Tip.style.display='block';
                    input.style.borderColor='red';
                }else{
                    Tip.style.display='none';
                    input.style.borderColor='#e5e5e5';
                }
            },
            //回收站
            recovery(){
                let parm= {pageNumber:1,length:this.pageSize,keyword:""};
                this.ispageSize = true;
                this.state = 0
                this.isBin = true;
                this.searchBinVal= "";
                this.getBinList(parm)
            },
            //启用
            enableCom(){
                let parm = {id:this.nowObj.id}
                this.get('/Company/enable',parm).then((res)=>{
                    if(res.success){
                        this.$message({
                            message: '启用成功',
                            type: 'success'
                        });
                        this.dataList[this.setIndex].state = 1
                    }else{
                        this.$message({
                            message: `启用失败:${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false
                    this.enableShow = false
                })
            },
            //停用
            disCom(){
                let parm = {id:this.nowObj.id}
                this.get('/Company/disable',parm).then((res)=>{
                    if(res.success){
                        this.$message({
                            message: '停用成功',
                            type: 'success'
                        });
                        this.dataList[this.setIndex].state = 2
                    }else{
                        this.$message({
                            message: `停用失败:${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false
                    this.disShow = false
                })
            },
            recoveryCom(){
                let parm={id:this.nowObj.id};
                this.get('/Company/restore',parm).then((res)=>{
                    // console.log(res,parm)
                    if(res.success){
                        this.$message({
                            message: '恢复成功',
                            type: 'success'
                        });
                        this.recoveryList.splice(this.setIndex,1)
                    }else{
                        this.$message({
                            message: `恢复失败:${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false
                    this.recoveryShow = false
                })
            },
            changeRadio(val){
                // console.log(val,this.ruleForm.radio)
                if(val!=this.ruleForm.radio){
                    this.$nextTick(()=>{
                        this.ruleForm.radio = val
                    })
                }
                if(val==2){
                    this.ruleForm.autoStop = 0
                }
            },
            // 用户提权
            // 用户提权
            Privilege(){
                this.$refs.verifyCode.validate((valid) => {
                    if (valid) {
                        this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                            if(res.success){
                                this.$message({
                                    message:'提权成功',
                                    type:'success'
                                })
                                this.VerifyArr.splice(this.VerifyArr.indexOf(2),1)
                                localStorage.setItem('verifyCodeModule',this.VerifyArr)
                                this.$store.state.mask=false
                                this.functionShow=false
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                                this.verifyForm.verifyCode = ''
                            }else{
                                this.$message({
                                    message:`提权失败：${res.message}`,
                                    type:'warning'
                                })
                            }
                        })
                    }
                })
            },
        },
        watch: {
            // isBin(){
            //     if(!this.isBin){
            //         this.isCount = true
            //         let parm={
            //             pageNumber:1,
            //             length:this.pageSize,
            //             state:1
            //         }
            //         this.searchVal = '';
            //         this.getlist(parm)
            //     }
            // }
        },
    };
</script>
<style scoped>
    .organizeBox{
        position: absolute;
        top: 36px;
        bottom: 0;
    }
    .date .el-date-editor{
        width: 370px !important;
    }
    .addMax{
        margin-top: 35px;
    }
    .logo span{
        float: left;
        margin: 0 5px;
    }
    .logo-box{
        position: relative;
        cursor: pointer;
    }
    .logo-box img{
        width: 96px;
        height: 96px;
        border-radius: 5px;
    }
    .logo span:last-child{
        margin-top: 73px
    }
    .or-Superior{
        width:370px;
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 10px;
        position: relative;
        box-sizing: border-box;
    }
    .company-bin{
        font-size: 16px;
        text-align: left;
        padding:0 16px;
        margin-top:6px ;
        cursor: pointer;
    }
    .organize{
        position: absolute;
        top: 40px;
        bottom: 0;
    }
    .select-box{
        position: absolute;
        left: -1px;
        top: 32px;
        border: 1px solid #e5e5e5;
        max-height: 315px;
        overflow: auto;
        width: 370px;
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .or-Superior i{
        float: right;
    }
    .or-Superior img{
        width: 22px;
        margin-top: 6px;
    }
    .root-obj{
        padding-left: 10px;
        cursor:pointer;
        position: relative;
        line-height: 28px;
        top: 4px;
    }
    .root-obj:hover{
        background-color: #f5f7fa;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top: -43px;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 36px;
        left: 328px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: 90.5%;
        max-height: 90.5% !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .nullDataBox{
        position: absolute;
        top:400px;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .min-158{
        min-width: 158px !important;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .popup>div{
        position: fixed;
        top: 12%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left: -407px;
        width: 578px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    i img.zuo{
        width: 14px;
        position: relative;
        top: 1px;
        margin-right: 5px;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-del .popup-title{
        margin-bottom: 12px;
    }
    .btn-box{
        text-align: center;
        margin-top: 30px;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .popup-clear{
        width: 436px !important;
        margin-left:-334px !important;
        text-align: left;
    }
    .phone,.verifyCode{
        width: 100%;
        border: 1px solid #e5e5e5;
        line-height: 34px;
        font-size: 14px;
        border-radius: 5px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .verifyCode{
        width: 255px;
        border: 0 ;
        padding: 0;
    }
    .code-box {
        float: right;
        width: 110px;
        line-height: 34px;
        text-align: center;
        color: #fff;
    }
    .get-code{
        background-color: #409eff;
        border-radius: 5px;
    }
    .countdown{
        background-color: #c2c2c2;
        border-radius: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .popup-edit,.popup-add{
        width: 886px !important;
        top: 0 !important;
        margin-left: -443px !important;
        padding:20px 20px 35px 31px;
    }
    .edit-content div{
        float: left;
        box-sizing: border-box;
        text-align: left;
    }
    .bg{
      width: 100%;
      margin-top: 42px;
      height: 90%;
    }
    .left-box{
        width: 430px;
    }
    .right-box{
        width: 386px;
    }
    .left-title{
        line-height: 32px;
        font-size: 15px;
        /* color: #5087e4; */
    }
    .edit-name,.edit-abbreviation,.edit-tit,.edit-point,.industry{
        width: 370px;
        height: 32px;
        line-height: 32px;
        border: 1px solid #dedede;
        border-radius: 5px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .industry{
        padding: 0;
    }
    .logoTip{
        position: absolute;
        top: 136px;
    }
    .industry{
        height: 34px;
        line-height: 34px;
        background-position: 340px;
        border: 0;
    }
    .red{
        color: #F56C6C;
        line-height: 20px;
        font-size: 14px;
        position: absolute;
        display: none;
    }
    .m-t-16{
        margin-top: 16px;
    }
    .btn-box button{
        margin-right: 46px;
        margin-left: 0;
    }
    .btn-box button:last-child{
        margin-right:0 ;
    }
    .file{
        display: none;
    }
    .p-r{
        position: relative;
    }
    .m-t-48{
        margin-top: 48px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .popup-delDevice,.popup-del{
        height: 284px;
    }
    .b-38{
        position: absolute;
        bottom: 38px;
    }
    .m-b-22{
        margin-bottom: 22px !important;
    }
    .top-0{
        margin-top: 0 !important;
    }
</style>
<!-- 修改默认样式 -->
<style>
    .tree-box .el-tree-node__content{
        padding-left: 14px !important;
    }
    .tree .el-tree-node{
        width: 263px;
        padding-right: 30px;
        box-sizing: border-box;
    }
    .popup .is-required .el-form-item__label{
        color: #2f3a4e;
    }
    .date .el-input__prefix i{
        position: relative;
        left: 330px;
        top: -2px;
    }
    .date .search-input input{
        line-height: 34px !important;
        height: 34px !important;
    }
    #company .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
        width: 370px !important;
    }
    #company .verifyCode #verifyCode2{
        width: 255px !important;
    }
    #company .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 12px !important;
    }
    #company .popup .el-form-item__label{
        padding: 0 !important;
    }
    #company .popup .el-form-item__content{
        line-height: 34px !important;
    }
    .date .el-input__inner,.province .el-input__inner,.city .el-input__inner,.industry .el-input__inner,.search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    .industry .el-icon-arrow-up,.search .el-icon-search{
        line-height: 34px !important;
    }
    .province .el-icon-arrow-up,.city .el-icon-arrow-up{
        line-height: 0 !important;
    }
    #company .el-button--primary.is-disabled{
        background-color: #a0cfff ;
        border-color: #a0cfff ;
    }
    #company .popup .el-radio-group{
        width: 100%;
        margin-bottom: 12px;
    }
    #company .el-date-editor--date .el-input__prefix{
        left: 335px !important;
        top: -3px !important;
    }
    #company .province .el-input__inner{
        margin-right: 1%;
    }
    #company .province .el-input__inner,#company .city .el-input__inner{
        float: left;
        width: 183px !important;
        height: 34px !important;
        line-height: 34px !important;
    }
    #company .city .el-input__inner{
        margin-left:5px !important;
    }
    #company .province .el-input--suffix,#company .city .el-input--suffix{
        height: 34px;
    }
    #company .address .el-form-item__label{
        width: 100% !important;
        text-align: left !important;
    }
    #company .remarks textarea{
        width: 370px !important;
        height: 76px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box;
        line-height: 20px !important;
        overflow: hidden;
    }
    #company .el-input__count{
        right: 22px !important;
        bottom: 2px !important;
        line-height: 22px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Company/company.vue